export class SearchUserError extends Error {
}